import React from "react";

const LeafGreen = () => {
  return (
    <svg fill="none" viewBox="0 0 42 17">
      <path fill="#43B05E" d="M19.6551.409729c7.2499-.906884 21.365 4.506631 21.365 4.506631S26.6345 14.9996 20.667 16.4456C13.6664 17.8735.0768103 11.9524.0768103 11.9524S14.7343 1.09891 19.6551.409729Z"/>
    </svg>
  )
}

export default LeafGreen